import { instance } from '../fetchService'

export const fetchStrengthPlans = () => instance.get('strength_plans')
export const fetchStrengthPlan = id => instance.get(`strength_plans/${id}`)

export const createStrengthPlan = plan => instance.post('strength_plans', plan)

export const saveStrengthPlan = plan =>
  instance.put(`strength_plans/${plan.id}`, plan)
